import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import List from 'components/List';

import Loader from 'components/layout/Loader';

import InvoicesList from 'components/layout/financial/InvoicesList';

class OrderInvoices extends React.Component {
  render() {
    const { entity, entityLoaded, list } = this.props;

    return !entityLoaded ? (
      <Loader />
    ) : (
      <div class="clearfix padding-20 sm-padding-10">
        <List
          noRender
          listName="orderInvoices"
          url="/api/invoices.json"
          urlData={{ filters: { order: entity.getId() } }}
          list={list}
        />

        {list.pending ? <Loader /> : <InvoicesList list={list.data.list} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.orderInvoices,
  };
};

export default withRouter(connect(mapStateToProps)(OrderInvoices));
